import { NAVY } from 'styles/Colors';
import { styled } from '@mui/material/styles';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import Diversity1OutlinedIcon from '@mui/icons-material/Diversity1Outlined';
import EventAvailableOutlinedIcon from '@mui/icons-material/EventAvailableOutlined';
import EventRepeatOutlinedIcon from '@mui/icons-material/EventRepeatOutlined';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FindInPageOutlinedIcon from '@mui/icons-material/FindInPageOutlined';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import React from 'react';
import SpeedOutlinedIcon from '@mui/icons-material/SpeedOutlined';
import SupportAgentOutlinedIcon from '@mui/icons-material/SupportAgentOutlined';

const accordionHeaderStyle = {
  color: NAVY,
  fontSize: '1rem',
  fontWeight: 700,
  marginLeft: '1rem'
};

const accordionSummaryStyle = {
  display: 'flex',
  flexDirection: 'row',
  marginLeft: '1rem',
  alignItems: 'center'
};

const accordionDetailsStyle = {
  fontSize: '1rem'
};

const mobileStyle = {
  margin: '0 1rem 0',
  justifyContent: 'center'
};

const supStyle = {
  verticalAlign: 'super',
  fontSize: '0.6rem'
};

const Accordion = styled((props) => <MuiAccordion {...props} />)({
  marginBottom: '0 !important'
});

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ExpandMoreIcon sx={{ fontSize: '1.5rem', color: NAVY }} />}
    {...props}
  />
))({
  padding: 0,
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(180deg)'
  },
  marginRight: '1rem'
});

const AccordionDetails = styled((props) => <MuiAccordionDetails {...props} />)({
  padding: '0.2rem 1rem 1rem'
});

function MobileCollapsibleAccordion({ icon, title, subtext }) {
  const Icon = icon;
  return (
    <div css={{ marginBottom: '1rem' }}>
      <Accordion elevation={0} disableGutters>
        <AccordionSummary
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <div css={accordionSummaryStyle}>
            <Icon css={{ color: NAVY }} />
            <h3 css={accordionHeaderStyle}>{title}</h3>
          </div>
        </AccordionSummary>

        <AccordionDetails>
          <div css={accordionDetailsStyle}>{subtext}</div>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}

function MobileSection() {
  return (
    <div css={mobileStyle}>
      <MobileCollapsibleAccordion
        icon={EventAvailableOutlinedIcon}
        title='Same-Day Funding Available'
        subtext={
          <p>
            If approved, you may receive money in your account as soon as the
            same business day!<span css={supStyle}>1</span>
          </p>
        }
      />
      <MobileCollapsibleAccordion
        icon={Diversity1OutlinedIcon}
        title='Referral Rewards'
        subtext='You could earn a $50 gift card* for a qualifying referral to OppLoans.'
      />
      <MobileCollapsibleAccordion
        icon={SpeedOutlinedIcon}
        title='FICO® Score'
        subtext={
          <p>
            OppLoans only does a soft credit check so applying won’t negatively
            impact your FICO® score.
            <span css={supStyle}>2</span>
          </p>
        }
      />
      <MobileCollapsibleAccordion
        icon={SupportAgentOutlinedIcon}
        title='Loan Support at Every Step'
        subtext='Our top-rated Customer Advocates are available to provide support at every step of the application process. We succeed when you do!'
      />
      <MobileCollapsibleAccordion
        icon={FindInPageOutlinedIcon}
        title='No Hidden Fees'
        subtext='No origination fee, no application fee, no prepayment fees.'
      />
      <MobileCollapsibleAccordion
        icon={EventRepeatOutlinedIcon}
        title='Repayment Schedule'
        subtext='Predictable and easy-to-read payment schedule.'
      />
      <MobileCollapsibleAccordion
        icon={AccountBalanceOutlinedIcon}
        title='Build Credit History'
        subtext={
          <p>
            We report your payment history with us to the three major credit
            bureaus, so every on-time payment you make may help boost your
            credit history.<span css={supStyle}>6</span>
          </p>
        }
      />
    </div>
  );
}

export default MobileSection;
